import { connect } from 'react-redux';
import ReturnToSenderFlow from './ReturnToSenderFlow';

function mapStateToProps({ payCard, wallet }) {
  const { isOverdue, wasReturned, wasReshipped, requiresConfirmation } = payCard;
  const { shipping_address: address } = wallet.status;

  return {
    address,
    isOverdue,
    requiresConfirmation,
    wasReshipped,
    wasReturned,
  };
}

export default connect(mapStateToProps)(ReturnToSenderFlow);
